export default "__VITE_PUBLIC_ASSET__14604724__"